export default "__VITE_ASSET__DIXDGx48__"